var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1518_27156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.7265 1.72659C9.47317 1.47325 9.13317 1.33325 8.77984 1.33325H3.99984C3.2665 1.33325 2.6665 1.93325 2.6665 2.66659V13.3333C2.6665 14.0666 3.25984 14.6666 3.99317 14.6666H11.9998C12.7332 14.6666 13.3332 14.0666 13.3332 13.3333V5.88658C13.3332 5.53325 13.1932 5.19325 12.9398 4.94659L9.7265 1.72659ZM9.99984 11.9999H5.99984C5.63317 11.9999 5.33317 11.6999 5.33317 11.3333C5.33317 10.9666 5.63317 10.6666 5.99984 10.6666H9.99984C10.3665 10.6666 10.6665 10.9666 10.6665 11.3333C10.6665 11.6999 10.3665 11.9999 9.99984 11.9999ZM9.99984 9.33325H5.99984C5.63317 9.33325 5.33317 9.03325 5.33317 8.66658C5.33317 8.29992 5.63317 7.99992 5.99984 7.99992H9.99984C10.3665 7.99992 10.6665 8.29992 10.6665 8.66658C10.6665 9.03325 10.3665 9.33325 9.99984 9.33325ZM8.6665 5.33325V2.33325L12.3332 5.99992H9.33317C8.9665 5.99992 8.6665 5.69992 8.6665 5.33325Z",
    fill: "#00A0F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1518_27156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/AttachmentIcon.b3051287b3ce187ff5c1a674dee42744.svg";
export { ForwardRef as ReactComponent };